module.exports = __webpack_public_path__ + "8921614844dcd7d610d79a36bf319859.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/termine/truecolors.jpg
// module id = 872
// module chunks = 0